import React, { Component } from "react";
import Sound from "./Sound";
import Share from "./Share";

import "./App.css";

class App extends Component {
  render() {
    const sounds = [
      {
        original: "Buongiorno Girini",
        translated: "Goeiedag Girovolger",
        sound: require("./sounds/girini_welkom.mp3"),
        trigger: "q"
      },
      {
        original: "La grande partenza",
        translated: "De grote start",
        sound: require("./sounds/grande_partenza.mp3"),
        trigger: "s"
      },
      {
        original: "Battistrada",
        translated: "Vluchter",
        sound: require("./sounds/battistrada.mp3"),
        trigger: "d"
      },
      {
        original: "Radio corsa",
        translated: "Wedstrijdradio",
        sound: require("./sounds/radio_corsa.mp3"),
        trigger: "f"
      },
      {
        original: "Spettacolo",
        translated: "Spektakel",
        sound: require("./sounds/spettacollo.mp3"),
        trigger: "g"
      },
      {
        original: "Gruppo compatto",
        translated: "Peloton",
        sound: require("./sounds/gruppo_compatto.mp3"),
        trigger: "h"
      },
      {
        original: "Ultimo chilometro",
        translated: "Laatste kilometer",
        sound: require("./sounds/ultimo_chilometro.mp3"),
        trigger: "j"
      },
      {
        original: "A domani",
        translated: "Tot morgen",
        sound: require("./sounds/a_domani.mp3"),
        trigger: "k"
      }
    ];

    return (
      <div
        className="App"
        style={{
          backgroundImage: `url(${require("./images/renaat.jpg")})`
        }}
      >
        <div className="container">
          <div className="logo">
            <img src={require("./images/logo.png")} />
          </div>
          <div className="buttons">
            {sounds.map(sound => (
              <Sound key={`sound-${sound.original}`} {...sound} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js